import React from "react"
import { EmptyData, NoSearchResults } from "../../utils/constants"
import "./index.css"
import {
  DoctorTableRow,
  PatientTableRow,
  CommonTable,
} from "../GlobalComponents/Table"

function CommonUserCards(props) {
  const {
    usersData,
    searchValue,
    isLoading,
    headerKeys = [],
    isPatientData = true,
    observer,
    loadingStatus="hide",
    tableContainerRef
  } = props

  const handleEdit = (userData) => {
    if (userData) {
      props.handleEdit(userData)
    }
  }

  if (!isLoading && usersData.length === 0) {
    return (
      <div className="center-container items-container">
        <h1 style={{ margin: 0, padding: 0 }}>
          {searchValue ? NoSearchResults : EmptyData}
        </h1>
      </div>
    )
  }

  return (
    <div className="table-container-div" ref={tableContainerRef}>
      <CommonTable
        rowData={usersData}
        headerKeys={headerKeys}
        rowComponent={(data) =>
          isPatientData ? (
            <PatientTableRow rowData={data} />
          ) : (
            <DoctorTableRow rowData={data} />
          )
        }
        onPressRow={handleEdit}
        observerRef={observer}
        loadingStatus={loadingStatus}
      />
    </div>
  )
}

export default CommonUserCards
